import React from 'react';

// components
import MaskedInput from 'react-text-mask';

const PhoneNumberInput = function(props) {
  return (
    <MaskedInput guide={ false }
      mask={ ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] }
      { ...props } />
  );
};

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./app/components/shared/form/_PhoneNumberInput.jsx